import axios from 'axios';
import { ICarePlanModel, ICarePlanModelPayload } from 'entities/CarePlan/CarePlan.models';

const ccmPath = 'ccm';

export const carePlanTransport = {
  updateCarePlanModel: (payload: ICarePlanModelPayload): Promise<ICarePlanModel> => axios.patch(`${ccmPath}/care-plan`, payload),
};
